import React, { createContext, useState, useContext } from 'react'
import { useWindowSize } from '../hook/useWindowSize'
import { useSelector } from 'react-redux'

const HideInputContext = createContext()

export const useHideInput = () => useContext(HideInputContext)

const HideInputProvider = ({ children }) => {
  const [hidingStatus, setHiding] = useState(false) //this is triggered by manual
  const { websiteMode } = useSelector(state => state.common)
  const windowSize = useWindowSize()

  return (
    <HideInputContext.Provider
      value={{
        hiding:
          (hidingStatus ||
            (websiteMode !== 'Normal' && websiteMode !== 'ShareEditingMode')) &&
          windowSize.width > 1225,
        showShield:
          hidingStatus ||
          (websiteMode !== 'Normal' && websiteMode !== 'ShareEditingMode'),
        shareModeActive:
          websiteMode !== 'Normal' && websiteMode !== 'ShareEditingMode',
        setHiding,
      }}
    >
      {children}
    </HideInputContext.Provider>
  )
}

export default HideInputProvider
